module.exports = __webpack_public_path__ + "img/3-up.abe31199.svg";